import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Modern Truncated Pagination Component
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 7;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <nav aria-label="Page navigation" className="mt-4">
      <ul className="pagination justify-content-center align-items-center gap-2 border-0 m-0">
        {/* Prev Page Button */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="btn d-flex align-items-center justify-content-center p-0"
            style={{
              width: "38px",
              height: "38px",
              borderRadius: "8px",
              border: "1px solid #E5E7EB",
              backgroundColor: currentPage === 1 ? "#F3F4F6" : "#FFFFFF",
              color: currentPage === 1 ? "#9CA3AF" : "#374151",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              transition: "all 0.2s ease",
            }}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Previous Page"
          >
            <ChevronLeft size={18} />
          </button>
        </li>

        {/* Page Items & Ellipsis */}
        {pageNumbers.map((page, index) => {
          if (page === "...") {
            return (
              <li key={`ellipsis-${index}`} className="page-item disabled">
                <div
                  className="d-flex align-items-center justify-content-center text-muted fw-bold"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "8px",
                    border: "1px solid #E5E7EB",
                    backgroundColor: "#F9FAFB",
                    color: "#6B7280",
                    fontSize: "14px",
                  }}
                >
                  ...
                </div>
              </li>
            );
          }

          const isActive = currentPage === page;

          return (
            <li key={page} className={`page-item ${isActive ? "active" : ""}`}>
              <button
                className="btn d-flex align-items-center justify-content-center p-0"
                style={{
                  width: "38px",
                  height: "38px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: isActive ? "700" : "500",
                  color: isActive ? "#0A77FF" : "#1F2937",
                  backgroundColor: isActive ? "#F4F8FF" : "#FFFFFF",
                  border: isActive ? "1.5px solid #0A77FF" : "1px solid #E5E7EB",
                  transition: "all 0.2s ease",
                  cursor: "pointer",
                }}
                onClick={() => onPageChange(page)}
              >
                {page}
              </button>
            </li>
          );
        })}

        {/* Next Page Button */}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="btn d-flex align-items-center justify-content-center p-0"
            style={{
              width: "38px",
              height: "38px",
              borderRadius: "8px",
              border: "1px solid #E5E7EB",
              backgroundColor: currentPage === totalPages ? "#F3F4F6" : "#FFFFFF",
              color: currentPage === totalPages ? "#9CA3AF" : "#374151",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              transition: "all 0.2s ease",
            }}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Next Page"
          >
            <ChevronRight size={18} />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
